import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUnauthMessage = defineStore('unauth_message', () => {
  const message = ref<any>(null)

  function getMessage(){
    return message.value
  }

  function setMessage(data: any) {
    message.value = data
  }


  function clear() {
    message.value = null
  }

  return { getMessage, setMessage, clear }
})
